<template>
  <div class="project">
    <div class="image_wrapper">
      <img v-bind:src="imgUrl" alt="project image"/>
    </div>
    <div class="wrapper">
      <h2>{{title}}</h2>
      <p>{{desc}}</p>
      <router-link  v-if="caseStudy" to="/PShare" @click.native="$scrollToTop">
        <div class="button">
          Read case study
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'project',
    props: {
      imgUrl: String,
      title: String,
      desc: String,
      caseStudy: Boolean
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/scss/_variables";

  .project {

    overflow: hidden;
    margin-top: 40px;

    @media screen and (min-width: $tablet-min) and (max-width: $tablet-max) {
      margin-top: 100px;
    }

    @media screen and (min-width: $screen-L-min) and (max-width: $screen-L-max) {
      margin-left: 10%;
      margin-right: 10%;
    }

    @media screen and (min-width: $screen-XL-min) {
      margin-left: 15%;
      margin-right: 15%;
    }

    .image_wrapper {
      margin: 0 -2px;

      img {
        margin: 0;
        width: 100%;

        @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
          float: left;
          width: 44%;
          margin: 0 1% 0 5%;
        }

        @media screen and (min-width: $screen-L-min) {
          float: left;
          width: 33%;
          margin: 0 1% 0 15%;
        }
      }



    }

    .wrapper {

      @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
        margin: 0 5% 0 1%;
        float: right;
        width: 44%;
      }

      @media screen and (min-width: $screen-L-min) {
        margin: 0 5% 0 20px;
        float: left;
        width: 33%;
      }
    }

    h2 {
      margin: 15px $margin-left;
      font-size: 21px;

      @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
        margin: 0;
        margin-bottom: 4px;
      }

      @media screen and (min-width: $screen-L-min) and (max-width: $screen-L-max) {
        margin: 0;
        margin-bottom: 4px;
      }

      @media screen and (min-width: $screen-L-min) {
        margin: 0;
        margin-bottom: 14px;
      }
    }

    p {
      margin: 15px $margin-left;
      font-size: 16px;
      height: 156px;
      line-height: 1.6em;

      @media screen and (min-width: $screen-min) {
        margin: 0;
      }
    }

    a {
      text-decoration: none;
    }

    .button {
      width: 218px;
      height: 42px;
      border-radius: 26.5px;
      border: solid 2px $light-blue;
      background-color: $white;
      line-height: 42px;
      text-align: center;
      font-size: 16px;
      color: $light-blue;
      margin: $margin-left auto;
      cursor: pointer;

      @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
        margin: 20px 0 0 0;
        font-size: 14px;
      }

      @media screen and (min-width: $screen-L-min) {
        margin: 20px 0 0 0;
        font-size: 14px;
      }
    }



  }

</style>
